import { ProductFeature, UseAuthProviderReturnType } from '@localstack/types';

type Props = {
  useAuthProvider: () => UseAuthProviderReturnType;
};

export const hasSnowflakeAccess = (hasFeature: (feature: ProductFeature, variant?: string) => boolean): boolean =>
  hasFeature(ProductFeature.FEATURE_SNOWFLAKE);

export const hasOnlySnowflakeAccess = (hasFeature: (feature: ProductFeature, variant?: string) => boolean): boolean => {
  // this is some ugly way of enabling the required behavior
  // problem with fetching subscriptions is that workspace members might not have the permissions
  // hence resorting to looking if the user has access to a service that's not in snowflake subs
  // and if the user has access to snowflake
  const hasLambda = hasFeature(ProductFeature.FEATURE_LOCALSTACK_AWS_PROVIDER, '/^lambda:.+$/');
  return hasSnowflakeAccess(hasFeature) && !hasLambda;
};

export const useHasOnlySnowflakeAccess = ({ useAuthProvider }: Props): boolean => {
  const { hasFeature } = useAuthProvider();
  return hasOnlySnowflakeAccess(hasFeature);
};
